export const SET_LOADER = 'SET_LOADER'

export const RESET_LOADER = 'RESET_LOADER'

export const SET_LOADER_WITH_TEXT = 'SET_LOADER_WITH_TEXT'

export const SET_USUARIO = 'SET_USUARIO'

export const CLEAR_USUARIO = 'CLEAR_USUARIO'

export const SET_USUARIO_PERMISSOES = 'SET_USUARIO_PERMISSOES'

export const SET_PROCESSO = 'SET_PROCESSO'

export const SET_TIPOS_PROCESSOS = 'SET_TIPOS_PROCESSOS'

export const SET_STATUS = 'SET_STATUS'

export const SET_PROCESSOS = 'SET_PROCESSOS'

export const SET_COUNT_PROCESSOS = 'SET_COUNT_PROCESSOS'

export const CLEAR_PROCESSOS = 'CLEAR_PROCESSOS'

export const SET_FILTRO_PROCESSOS = 'SET_FILTRO_PROCESSOS'

export const SET_MUNICIPIOS = 'SET_MUNICIPIOS'

export const SET_MUNICIPIOS_PA = 'SET_MUNICIPIOS_PA'

export const SET_DIALOG_VISIBLE = 'SET_DIALOG_VISIBLE'

export const SET_MENU = 'SET_MENU'

export const SET_FIELD_VALUE = 'SET_FIELD_VALUE'

export const SET_CONSTANTS = 'SET_CONSTANTS'

export const SET_CUSTA = 'SET_CUSTA'

export const SET_VTN = 'SET_VTN'

export const CLEAR_VTN = 'CLEAR_VTN'

export const SET_MENSAGENS_PROCESSO = 'SET_MENSAGENS_PROCESSO'

export const SET_CONVERSAS_PROCESSO = 'SET_CONVERSAS_PROCESSO'

export const SET_NOVAS_NOTIFICACOES = 'SET_NOVAS_NOTIFICACOES'

export const SET_CONVERSAS_TIPO = 'SET_CONVERSAS_TIPO'

export const SET_NOTIFICACOES = 'SET_NOTIFICACOES'

export const CLEAR_NOTIFICACOES = 'CLEAR_NOTIFICACOES'

export const SET_CONVERSA_MENSAGENS = 'SET_CONVERSA_MENSAGENS'

export const SET_RESPOSTA_CONTEUDO = 'SET_RESPOSTA_CONTEUDO'

export const SET_CONVERSA_RESPOSTA = 'SET_CONVERSA_RESPOSTA'

export const ADD_ANEXO = 'ADD_ANEXO'

export const REMOVE_ANEXO = 'REMOVE_ANEXO'

export const SET_RESPOSTA_ANEXO = 'SET_RESPOSTA_ANEXO'

export const CLEAR_DOCUMENTO_AUTENTICO = 'CLEAR_DOCUMENTO_AUTENTICO'

export const SET_DOCUMENTO_AUTENTICO = 'SET_DOCUMENTO_AUTENTICO'

export const SET_RECEITAS = 'SET_RECEITAS'

export const SET_DAE = 'SET_DAE'

export const SET_ITEMS_LISTAGEM = 'SET_ITEMS_LISTAGEM'

export const SET_TOTAL_ITEMS_LISTAGEM = 'SET_TOTAL_ITEMS_LISTAGEM'

export const SET_CADASTRO_ORIGINAL = 'SET_CADASTRO_ORIGINAL'

export const CLEAR_CADASTRO = 'CLEAR_CADASTRO'

export const SET_BOLETO_DAE = 'SET_BOLETO_DAE'

export const SET_CONFIGURACAO = 'SET_CONFIGURACAO'

export const SET_MAIN_CARD = 'SET_MAIN_CARD'

export const ADD_UPLOAD = 'ADD_UPLOAD'

export const SET_OS_NUMERO = 'SET_OS_NUMERO'

export const CLEAR_OS_ANALISTAS = 'CLEAR_OS_ANALISTAS'

export const SET_ANALISTAS = 'SET_ANALISTAS'

export const CHANGE_ANALISTA_SELECIONADO = 'CHANGE_ANALISTA_SELECIONADO'

export const CLEAR_PROCESSOS_SELECIONADOS = 'CLEAR_PROCESSOS_SELECIONADOS'

export const SET_PROCESSOS_SELECIONADOS = 'SET_PROCESSOS_SELECIONADOS'

export const ADD_SUB_PROCESSO_SELECIONADOS = 'ADD_SUB_PROCESSO_SELECIONADO'

export const SET_NULL_USUARIO_SUB_PROCESSO = 'SET_NULL_USUARIO_SUB_PROCESSO'

export const SET_USUARIO_SUB_PROCESSO = 'SET_USUARIO_SUB_PROCESSO'

export const SET_ORDEM_SERVICO = 'SET_ORDEM_SERVICO'

export const CLEAR_ORDEM_SERVICO = 'CLEAR_ORDEM_SERVICO'

export const SET_LISTA_AUXILIAR = 'SET_LISTA_AUXILIAR'
